import { create } from 'zustand';

import type { User } from '@tasks/contracts';

/** Текущий пользователь — нужен realtime-слою (сравнение actorId) и хедерам. */

export type SessionState = {
  readonly user: User | null;
  setUser: (user: User | null) => void;
};

export const useSessionStore = create<SessionState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
}));

/** Императивный доступ вне React (realtime-обработчики). */
export function getCurrentUser(): User | null {
  return useSessionStore.getState().user;
}
